import * as React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import Button from "@mui/material/Button";
import { computeMutation } from "../utils/computeMutation";
import { ConfirmAction } from "../types";

type Props = {
  action: ConfirmAction;
  isOpen: boolean;
  handleNo: () => void;
  handleYes: (action: ConfirmAction) => Promise<void>;
};
export const ConfirmDialog = ({
  action,
  isOpen,
  handleYes,
  handleNo,
}: Props) => {
  const mutation = computeMutation(action);
  const noButtonRef = React.useRef<HTMLButtonElement>(null);

  const handleEntered = () => {
    // The `autoFocus` is not used because, if used, the same Enter that saves
    // the cell triggers "No". Instead, we manually focus the "No" button once
    // the dialog is fully open.
    // noButtonRef.current?.focus();
  };

  return (
    <Dialog
      maxWidth="xs"
      TransitionProps={{ onEntered: handleEntered }}
      open={isOpen}
    >
      <DialogTitle variant={"h3"}>Are you sure?</DialogTitle>
      <DialogContent dividers>{mutation}</DialogContent>
      <DialogActions>
        <Button ref={noButtonRef} onClick={handleNo}>
          No
        </Button>
        <Button onClick={() => handleYes(action)}>Yes</Button>
      </DialogActions>
    </Dialog>
  );
};
